import { render, staticRenderFns } from "./ContasPrincipal.vue?vue&type=template&id=89323ed4&scoped=true&"
import script from "./ContasPrincipal.vue?vue&type=script&lang=js&"
export * from "./ContasPrincipal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89323ed4",
  null
  
)

export default component.exports